<template>
  <b-container fluid>
    <b-row v-if="!isOwner && !$apollo.queries.contact._loading">
      <b-col>
        <AccessDenied />
      </b-col>
    </b-row>
    <div v-else>
    <b-row>
      <b-col>
        <router-link to="/contacts">
          <b-button variant="outline-primary" class="mb-3 mr-1"
            >Back to contacts</b-button
          >
        </router-link>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="3">
        <iq-card>
          <template v-slot:headerTitle>
            <h1 class="card-title text-left pt-2">
              {{ prettyName }}
            </h1>
          </template>
          <template v-slot:body>
            <div class="about-info m-0 p-0">
              <b-row>
                <b-col cols="3">Email:</b-col>
                <b-col cols="9">
                  <b-link>{{ contact.email }}</b-link>
                </b-col>
                <b-col cols="3">Phone:</b-col>
                <b-col cols="9">
                  <b-link>
                    {{ contact.phone ? contact.phone : "-" }}
                  </b-link>
                </b-col>
                <b-col cols="3">Company:</b-col>
                <b-col cols="9">
                  {{ contact.company ? contact.company.name : "-" }}
                </b-col>
                <b-col cols="3">Status:</b-col>
                <b-col cols="9">
                  <ContactStatusBadge :status="contact.status" />
                </b-col>
                <b-col cols="3">CX:</b-col>
                <b-col cols="9">{{ contact.cx }}</b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-left pt-2">Campaign statistics</h4>
          </template>
          <template v-slot:body>
            <div class="about-info m-0 p-0">
              <b-row>
                <b-col cols="3">Open&nbsp;Rate:</b-col>
                <b-col cols="9">
                  <b-link>
                    {{ contact.open_rate | formatPercentage | notAvailable }}
                    {{ !!contact.open_rate ? "%" : null }}
                  </b-link>
                </b-col>
                <b-col cols="3">CTR:</b-col>
                <b-col cols="9">
                  <b-link>
                    {{ contact.ctr | formatPercentage | notAvailable }}
                    {{ !!contact.ctr ? "%" : null }}
                  </b-link>
                </b-col>
                <b-col cols="3">Recency:</b-col>
                <b-col cols="9">
                  {{ contact.recency | formatDate | notAvailable }}
                </b-col>
              </b-row>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="9">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Leads</h4>
          </template>
          <template v-slot:body>
            <b-table
              hover
              responsive
              :items="leads"
              :fields="fields"
              class="mb-0 table-borderless"
              :sort-by="sortBy"
              :sort-desc="sortDesc"
              sort-icon-left
            >
              <template #table-busy>
                <div class="text-center p-4" style="color: var(--iq-primary)">
                  <b-spinner class="align-middle mr-3"></b-spinner>
                  <strong>Loading...</strong>
                </div>
              </template>
              <template v-slot:cell(cluster)="data">
                <LeadClusterBadge :cluster="data.value" />
              </template>
              <template v-slot:cell(contact)="data">
                <router-link
                  :to="{
                    path: `/leads/${data.item.id}`,
                  }"
                >
                  <b-button variant="link" style="color: var(--iq-primary)">
                    {{ data.value.first_name + " " + data.value.last_name }}
                  </b-button>
                </router-link>
                <!-- <DeletedBadge :deletedAt="data.item.deletedAt" /> -->
              </template>
              <template v-slot:cell(company)="data">
                <h6>{{ data.value ? data.value.name : "-" }}</h6>
              </template>
              <template v-slot:cell(stage_id)="data">
                <LeadStageBadge :stageId="data.value" />
              </template>
              <template v-slot:cell(campaign)="data">
                <h6>{{ data.value.name }}</h6>
              </template>
              <template v-slot:cell(last_activity)="data">
                <h6>{{ data.value | formatDate | notAvailable }}</h6>
              </template>
              <template v-slot:cell(priority_index)="data">
                <h6>{{ data.value }}</h6>
              </template>
              <template v-slot:cell(number_of_clicks)="data">
                <h6>{{ data.value }}</h6>
              </template>
              <template v-slot:cell(action)="data">
                <!-- <b-button
                  v-if="!data.item.deletedAt"
                  @click="toDeleteItem = data.item.id"
                  variant="outline-danger"
                  size="sm"
                >
                  <i class="ri-delete-bin-line m-0"></i>
                </b-button> -->
              </template>
            </b-table>
            <h5 v-if="leads.length === 0" class="text-center pt-4 pb-4">
              no leads available
            </h5>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">History timeline</h4>
          </template>
          <template v-slot:body>
            <TimeLine :events="events" />
          </template>
        </iq-card>
      </b-col>
    </b-row>
    </div>
  </b-container>
</template>
<script>
import { core } from "../../config/pluginInit";
import LeadStageBadge from "./Components/LeadStageBadge";
import ContactStatusBadge from "./Components/ContactStatusBadge.vue";
import DeletedBadge from "./Components/DeletedBadge";
import LeadClusterBadge from "./Components/LeadClusterBadge";
import IqCard from "../../components/core/cards/iq-card.vue";
import { getAccountSync } from "../../Utils/account";
import AccessDenied from './Components/AccessDenied.vue';

import gql from "graphql-tag";
const GET_CONTACT = gql`
  query getContact($id: uuid!) {
    contacts_by_pk(id: $id) {
      id
      first_name
      last_name
      email
      phone
      status
      cx
      open_rate
      ctr
      recency
      owner_id
      company {
        id
        name
      }
      leads {
        id
        stage_id
        cluster
        priority_index
        number_of_clicks
        number_of_opens
        contact {
          first_name
          last_name
          company {
            id
            name
          }
        }
        deal_value
        campaign {
          id
          name
        }
        last_activity
      }
    }
  }
`;
const LIST_EVENTS = gql`
  query listEvents($ids: [uuid!]) {
    events(where: { lead_id: { _in: $ids } }, order_by: { created_at: desc }) {
      id
      event_type
      created_at
      data
    }
  }
`;

export default {
  name: "ContactsDetail",
  components: {
    LeadStageBadge,
    ContactStatusBadge,
    LeadClusterBadge,
    IqCard,
    DeletedBadge,
    AccessDenied
  },
  mounted() {
    core.index();
  },
  data() {
    return {
      contact: {},
      events: [],
      sortBy: "priority_index",
      sortDesc: true,
      account: getAccountSync(),
      fields: [
        { key: "cluster", title: "Cluster", sortable: true },
        { key: "contact", title: "Contact", sortable: false },
        { key: "company", title: "Company", sortable: false },
        { key: "status", title: "Status", sortable: true },
        { key: "campaign", title: "Campaign", sortable: false },
        { key: "last_activity", title: "Last Activity", sortable: true },
        { key: "priority_index", title: "Priority Index", sortable: true },
        { key: "number_of_clicks", title: "Number of Click", sortable: true },
        { key: "action", title: "Action", sortable: false }
      ]
    };
  },
  apollo: {
    contact() {
      return {
        query: GET_CONTACT,
        variables: {
          id: this.$route.params.id
        },
        notifyOnNetworkStatusChange: true,
        update: data => data.contacts_by_pk
      };
    },
    events() {
      return {
        query: LIST_EVENTS,
        variables() {
          return {
            ids: this.leads.map(l => l.id)
          };
        }
      };
    }
  },
  computed: {
    prettyName() {
      if (this.contact.first_name || this.contact.last_name) {
        return `${this.contact.first_name || ""} ${this.contact.last_name ||
          ""}`;
      } else {
        return this.contact.email;
      }
    },
    leads() {
      if (this.contact.leads) {
        return this.contact.leads.map(lead => {
          return {
            id: lead.id,
            cluster: lead.cluster,
            contact: lead.contact,
            company: lead.contact.company,
            stage_id: lead.stage_id,
            campaign: lead.campaign,
            last_activity: lead.last_activity,
            priority_index: lead.priority_index,
            number_of_clicks: lead.number_of_clicks,
            number_of_opens: lead.number_of_opens,
            opened: lead.number_of_opens > 0 ? true : false,
            clicked: lead.number_of_clicks > 0 ? true : false
          };
        });
      } else {
        return [];
      }
    },
    isOwner(){
      if (this?.contact?.owner_id === this?.account?.userId) {
        return true
      }
      return false
    }
  },
  methods: {}
};
</script>
